import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    loginStatus: false,
    loginErrors: '',
    authenticated: false,
    user: null,
    // authenticated: false,
    userToken: localStorage.getItem('userToken') || '',
    // user: null,
    keywords: null,
    jsonData: [],
    originalJsonData: [],
    isBusy: false,
    albumUrl: 'https://adminapi.al-tarik.ly/public',
    publicUrl: 'https://adminapi.al-tarik.ly/public',
    rootUrl: 'https://adminapi.al-tarik.ly',
    // albumUrl: 'http://localhost/al-tarik/public',
    // publicUrl: 'http://localhost/al-tarik/public',
    // rootUrl: 'http://localhost/al-tarik',
    // State of search

    towns: [],
    selectedTown: '',
    locations: [],
    selectedLocation: '',
    propertyTypes: [],
    selectedType: '',
    categories: [],
    selectedCategory: ''
  },

  mutations: {
    SET_AUTHENTICATED (state, value) {
      state.authenticated = value.authenticated
      state.loginStatus = value.loginStatus
      state.loginErrors = value.loginErrors
    },
    ERROR_AUTHENTICATED (state, value) {
      state.loginStatus = value.loginStatus
      state.loginErrors = value.loginErrors
    },
    SET_USER (state, value) {
      state.user = value
    },

    dashboardData (state, payload) {
      state.customers = payload.customers
      state.userRequests = payload.userRequests
    }
  },
  actions: {
    async login ({ dispatch, commit }, credentials) {
      await axios.get('/sanctum/csrf-cookie')
      await axios.post('/login', credentials).then(() => {
        return dispatch('profile')
      }).catch(error => {
        console.log(typeof (error.response.status))
        if (error.response.status === parseInt(419)) {
          var loginStatus = false
        }
        let loginErrors = error.response.data.errors
        commit('ERROR_AUTHENTICATED', { loginStatus, loginErrors })
      })
    },

    async logout ({ dispatch }) {
      await axios.post('/logout')
      return dispatch('profile')
    },

    profile ({ commit }) {
      console.log('profile')
      return axios.get('/api/user').then(response => {
        let authenticated = true
        let loginStatus = false
        let loginErrors = ''
        commit('SET_AUTHENTICATED', { authenticated, loginStatus, loginErrors })
        commit('SET_USER', response.data.data)
      }).catch(() => {
        let authenticated = false
        let loginStatus = false
        let loginErrors = ''
        commit('SET_AUTHENTICATED', { authenticated, loginStatus, loginErrors })
        commit('SET_USER', null)
      })
    }
  },

  getters: {
    authenticated (state) {
      return state.authenticated
    },

    user (state) {
      return state.user
    },

    loginErrors (state) {
      return state.loginErrors
    }
  }
})

export default store
